import WeeklypayboyTile from '../../views/weeklyplayboy/tile.vue';

window.Vue.component('weeklypayboy-tile', WeeklypayboyTile);
